// Date helpers for the Translation Metrics Dashboard.
//
// Backend Coral validation requires `startDate` and `endDate` to be strict
// `YYYY-MM-DD` strings interpreted in the user's local timezone. We never send
// ISO timestamps over the wire — KatDateRangePicker emits full ISO timestamp
// strings, so the dashboard normalizes those at the boundary using
// `normalizeToLocalDateString`.

import { DateRange } from './types';

// Formats a Date as `YYYY-MM-DD` using the user's local timezone.
//
// Importantly this uses `getFullYear()/getMonth()/getDate()` rather than
// `toISOString()`, which would convert to UTC and shift the calendar day for
// users west of UTC late in the day.
export const formatLocalDate = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Accepts an ISO timestamp string (as emitted by KatDateRangePicker) or a
// Date and returns a `YYYY-MM-DD` string in the user's local timezone.
export const normalizeToLocalDateString = (value: string | Date): string => {
  const d = value instanceof Date ? value : new Date(value);
  return formatLocalDate(d);
};

// Default range for dashboard load: the last 30 days (inclusive of today),
// both endpoints formatted as `YYYY-MM-DD` in local time.
export const computeDefaultDateRange = (): DateRange => {
  const now = new Date();
  const past = new Date();
  past.setDate(now.getDate() - 30);
  return {
    startDate: formatLocalDate(past),
    endDate: formatLocalDate(now),
  };
};
